export const safeString = (value: unknown): string => (typeof value === 'string' ? value : String(value ?? ''))
